import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/video/bg.mp4'


const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass({ 'app-inner': true })
}
const _hoisted_2 = { class: "about content-wide" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "content-video-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "video-wrapper" }, [
    /*#__PURE__*/_createElementVNode("iframe", {
      src: "https://www.youtube.com/embed/39J8ehZ6Z1U",
      title: "Fire and Forget",
      frameborder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen: ""
    })
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "about-content" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Forever Young"),
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.rudetins.ch/",
      target: "__blank"
    }, "Rude Tins")
  ])
], -1)
const _hoisted_5 = { class: "music-container" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1)
const _hoisted_9 = { class: "socials-container" }
const _hoisted_10 = ["src", "alt", "onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("video", {
  autoplay: "",
  playsinline: "",
  muted: "",
  loop: "",
  id: "bg-vid"
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "video/mp4"
  })
], -1)
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookieConsent = _resolveComponent("CookieConsent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.musicItems, (e) => {
          return (_openBlock(), _createElementBlock("div", {
            key: e.name,
            class: "music-container-item",
            onClick: ($event: any) => (_ctx.openExternalLink(e.link))
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: require(`@/assets/img/socials/${e.icon}`),
                alt: e.title
              }, null, 8, _hoisted_7),
              _createElementVNode("h3", null, _toDisplayString(e.title), 1)
            ])
          ], 8, _hoisted_6))
        }), 128))
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socials, (e) => {
          return (_openBlock(), _createElementBlock("div", {
            key: e.title,
            class: "socials-container-item"
          }, [
            _createElementVNode("img", {
              src: require(`@/assets/img/socials_tr/${e.icon}`),
              alt: e.title,
              onClick: ($event: any) => (_ctx.openExternalLink(e.link))
            }, null, 8, _hoisted_10)
          ]))
        }), 128))
      ])
    ]),
    _hoisted_11,
    _createVNode(_component_CookieConsent),
    (_ctx.showShareButton)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sharePage())),
          class: "share-fab"
        }, [
          _createElementVNode("img", {
            src: require('@/assets/img/share.svg'),
            alt: "share"
          }, null, 8, _hoisted_12)
        ]))
      : _createCommentVNode("", true)
  ]))
}